import { useEffect as l } from "react";
var u = function u(_ref) {
  var n = _ref.isOpen,
    e = _ref.popupRef,
    s = _ref.isPopupPositionUnderVariable,
    c = _ref.variable;
  l(function () {
    if (n && e.current && s) {
      var t = e.current;
      t.style.transform = "none";
      var o = t.getBoundingClientRect(),
        r = o.bottom > window.innerHeight,
        i = o.right > window.innerWidth;
      if (i || r) {
        var a = "".concat(i ? "translateX(-100%)" : "", " ").concat(r ? "translateY(calc(-22px - 100%))" : "");
        t.style.transform = a;
      }
    }
  }, [n, c]);
};
export { u as useTextareaPopupPosition };